export default __webpack_public_path__ + "static/media/diverse02-1.5x.dc4cb876.png";